import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "status-cross-small-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.03 7.97a.75.75 0 0 1 0 1.06l-7 7a.75.75 0 0 1-1.06-1.06l7-7a.75.75 0 0 1 1.06 0Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.97 7.97a.75.75 0 0 1 1.06 0l7 7a.75.75 0 1 1-1.06 1.06l-7-7a.75.75 0 0 1 0-1.06Z"
    }, null, -1)
  ])))
}
export default { render: render }